module.exports = __webpack_public_path__ + "img/sec7desk.0b78e618.png";